import IAdministrator from './IAdministrator';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function transformAdministrator(administrator: IAdministrator): any {
    return {
        dealMaximumValue: administrator.dealMaximumValue,
        dealMinimumValue: administrator.dealMinimumValue,
        email: administrator.email,
        hubspotOwnerId: administrator.hubspotOwnerId,
        leadsAutoAssign: administrator.leadsAutoAssign,
        name: administrator.name,
        permissions: administrator.permissions,
        phone: administrator.phone,
        photoUrl: administrator.photoUrl,
        title: administrator.title,
    };
}
